<template>
  <v-container fluid>
    <PageHeading
      text="Справочники"
      mode="grid"
      :grid-data-loading="gridDataLoading"
      :results-count="resultsCount"
    >
      <template v-slot:[`toolbar.prepend`]>
        <v-btn
          link
          small
          outlined
          color="primary"
          class="mx-2 mt-2"
          :to="{
            name: 'page-dictionary-new'
          }"
        >
          <v-icon class="mr-2" small> mdi-plus </v-icon>
          Создать справочник
        </v-btn>
      </template>
    </PageHeading>
    <v-row>
      <v-col>
        <GridDictionaries ref="grid" />
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import GridDictionaries from './grid'
import PageHeading from '@/components/page-heading'
import gridPageInterface from '@/interfaces/grid-page-interface-mixin'

export default {
  name: 'PageDictionaries',
  components: {
    PageHeading,
    GridDictionaries
  },
  metaInfo () {
    return {
      title: 'Справочники'
    }
  },
  mixins: [gridPageInterface],
  data () {
    return {
      activeTab: 0
    }
  }
}
</script>
